module.exports = __webpack_public_path__ + "img/room15.109d0242.gif";